import {
  DialogPositionStrategyInIframe,
  ENVIRONMENTS,
  RETAILERS,
} from '@shared/constants';
import { Environment } from '@shared/models';

import '@angular/common/locales/global/fr';

export const environment: Environment = {
  lang: 'fr-FR',
  maxReward: 25,
  production: true,
  maintenance: false,
  baseHref: '/fr/',
  hasCampaignBis: false,
  maxSelectedChallenges: 6,
  retailerName: RETAILERS.NIX,
  env: ENVIRONMENTS.STAGING,
  projectType: 'loyaltyChallenge',
  backendUrl: 'https://b2c.mesdefispicard.ai.eagleeye.com/api/v2',
  dialogPositionStrategyInIframe: DialogPositionStrategyInIframe.DEFAULT,
  enableSentry: true,
  ssrAllowedHosts: ['*.uat.ai.eagleeye.com'],
};
